import { DimensionValue } from "./dimensions";
import { Pricing } from "./pricing";
import { IComponentConfig } from "@/app/@types/base-component";
import { ReactiveComponent } from "./base-component";
import { ref, Ref } from "vue";
import { ManagerInfo } from "@/models/estimate";
export interface ProgressInfo {
    status: string;
    updated: Date;
    validatedPage: number;
    activePage: number;
    activeSpaceCode: string;
    activeStructureCode: string;
    activeDoorCode: string;
    activeFillerCode: string;
    activeMountsCode?: string;
    isSaved: boolean;
}

export interface Client {
    name: string;
    businessName: string;
    email: string;
    phone: string;
    shippingAddress: string;
    billingAddress: string;
    billingZip: string;
    billingState: string;
}

export interface Estimate {
    title: string;
    code: string;
    started: Date;
    priceDate: number;
    priceDateFormated: string;
    dealTypeCode: string;
    installationPlaceCode: string;
    installationUsageCode: string;
    installedSystemCode: string;
    trackCode: string;
    estimateNo: string;
    colorCode: string;
    delivery: boolean;
    deliveryType: string;
    deliverySum: number;
    isIncludeCombinedDeliveryInPrice: boolean;
    isShippingAndBillingEqual: boolean;
    installation: boolean;
    shippingZip: string;
    shippingState: string;
    managerCode: ManagerInfo;
    estimatorCode: string;
    estimatorName: string;
    client: Client;
    progress: ProgressInfo;
    multiplicator: number;
    subtotal: Pricing;
    estimatePriceWithoutExtra: Pricing;
    estimatePrice: Pricing;
    discountPercent: number;
    discountSum: number;
    halfInstallation: number;
    installationSum: number;
    overChargeSum: number;
    halfInstallationWithDiscount: number;
    isHalfInstallation: boolean;
    totalSquareFt: DimensionValue | null;
    billingZip: string;
    billingState: string;
    priceBreakdownInQuote: boolean;
    totalWithoutTax: number;
    totalWithTax: number;
    taxPercent: number;
    taxSum: number;
    taxLimit: boolean;
    taxStatus: boolean;
    isTaxExempt: boolean;
    customerNotice: string;
    totalGlassWeight: number;
}

export type EstimateItemConfig = IComponentConfig & {
    width: number;
    height: number;
    servicePrice: number;
    overheadPrice: number;
    parentId: string;
};

export class EstimateItem extends ReactiveComponent {
    width: Ref<number>;
    height: Ref<number>;
    servicePrice: Ref<number>;
    overheadPrice: Ref<number>;
    parentId: Ref<string>;

    constructor(config: EstimateItemConfig) {
        super({ ...config, type: "estimate-item" });

        this.width = ref(config.width || 0);
        this.height = ref(config.height || 0);
        this.servicePrice = ref(config.servicePrice || 0);
        this.overheadPrice = ref(config.overheadPrice || 0);
        this.parentId = ref(config.parentId || "");
    }
}
